import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#8B0000', // Dark red
      light: '#B22222', // Firebrick red
      dark: '#660000', // Darker red
    },
    secondary: {
      main: '#4A0404', // Very dark red
      light: '#6D1515', // Lighter dark red
      dark: '#2D0000', // Almost black red
    },
    error: {
      main: '#FF0000', // Bright red for errors
    },
    warning: {
      main: '#FFA500', // Orange
    },
    info: {
      main: '#B22222', // Firebrick red for info
    },
    success: {
      main: '#006400', // Dark green (keeping this for good contrast)
    },
    background: {
      default: '#FAFAFA',
      paper: '#FFFFFF',
    },
    text: {
      primary: '#2D0000', // Very dark red for primary text
      secondary: '#4A0404', // Dark red for secondary text
    },
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          background: 'linear-gradient(45deg, #660000 30%, #8B0000 90%)',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        contained: {
          background: 'linear-gradient(45deg, #8B0000 30%, #B22222 90%)',
          '&:hover': {
            background: 'linear-gradient(45deg, #660000 30%, #8B0000 90%)',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          '&::placeholder': {
            color: 'rgba(74, 4, 4, 0.5)', // Using the secondary text color with 50% opacity
            opacity: 1,
          },
        },
      },
    },
  },
  typography: {
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
    ].join(','),
    h1: {
      fontSize: '2.5rem',
      fontWeight: 500,
    },
    h2: {
      fontSize: '2rem',
      fontWeight: 500,
    },
    h3: {
      fontSize: '1.75rem',
      fontWeight: 500,
    },
    h4: {
      fontSize: '1.5rem',
      fontWeight: 500,
    },
    h5: {
      fontSize: '1.25rem',
      fontWeight: 500,
    },
    h6: {
      fontSize: '1rem',
      fontWeight: 500,
    },
  },
});

export default theme;
